module.exports = __webpack_public_path__ + "img/ctrl-ising-stub-+i.ab895f80.svg";